export const routes = {
  public: {
    landing: '/',
    login: '/login',
    register: '/registro',
    resetPassword: '/recuperar',
    // Retorno de la pasarela externa tras pagar un link (pagos-zeus-3).
    paymentReturn: '/pago/retorno',
    terms: '/terminos',
    privacy: '/policy',
    // La URL de borrado de cuenta que se declara en Google Play.
    accountDeletion: '/eliminar-cuenta',
    // Las URL del conector de IA que se declaran en el registro MCP y en los
    // directorios de Claude y de ChatGPT: no se cambian una vez enviadas.
    aiConnector: '/conector-ia',
    aiConnectorPrivacy: '/conector-ia/privacidad',
    news: '/lo-ultimo',
    newsDetail: (id: string) => `/lo-ultimo/${id}`,
    // Histórico público de notas de versión (goal portal-notas-de-version-en-
    // vivo). Vivía solo escrito a mano en routeConfig y en los enlaces.
    releases: '/actualizaciones',
    releasesDeProducto: (repo: string) =>
      `/actualizaciones?repo=${encodeURIComponent(repo)}`,
    // Aplicaciones instalables del ecosistema (goal el-portal-lista-las-
    // aplicaciones-para-descargar). Es RUTA, no ancla de la portada.
    downloads: '/descargas',
  },
  app: {
    dashboard: '/app',
    organization: {
      detail: '/app/organization',
      new: '/app/organization/new',
    },
    businesses: {
      list: '/app/businesses',
      detail: (id: string) => `/app/businesses/${id}`,
      new: '/app/businesses/new',
    },
    services: '/app/services',
    // Lo nuevo de cada producto (goal novedades-del-portal 2): la página que
    // rescata a quien cerró el aviso de entrada sin leerlo.
    novedades: '/app/novedades',
    billing: {
      list: '/app/billing',
      detail: (id: string) => `/app/billing/${id}`,
    },
    credits: '/app/credits',
    tickets: {
      list: '/app/tickets',
      detail: (code: string) => `/app/tickets/${code}`,
      new: '/app/tickets/new',
    },
    users: '/app/users',
    // Gestión del equipo de la organización (goal portal-roles-2) — no
    // confundir con `users`, el CRM de staff del landing.
    team: '/app/equipo',
    statistics: '/app/statistics',
    admin: {
      landing: '/app/admin/landing',
      legal: '/app/admin/legal',
      news: '/app/admin/news',
      commercials: '/app/admin/commercials',
      difusion: '/app/admin/difusion',
      paymentGateways: '/app/admin/payment-gateways',
    },
  },
} as const
